import { Col, RadioGroupField } from '@/components';
import type { AnalysisSearchFormType } from '@/features/search/_models/analysis-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { AnalysisTargetLabelModifier, analysisTargetEnum } from '@/utils/enum';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const options = analysisTargetEnum.options.flatMap((value) => {
  return {
    value,
    label: AnalysisTargetLabelModifier[value],
  };
});

export const AnalysisTargetColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<AnalysisSearchFormType>();

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <RadioGroupField
        name="analysisTarget"
        label={t('analysis-target')}
        control={control}
        errors={errors}
        buttonStyle="solid"
        optionType="button"
        options={options}
        shouldCoexistOnChange
        onChange={({ target: { value } }) => {
          if (value === 'payment') {
            setValue('accountingType', null);
            setValue('accountingTypeIds', null);
            setValue('aggregationType', 'payment');
            setValue('aggregationTargetType', 'total');
          } else {
            setValue('aggregationType', 'finalized');
          }
        }}
      />
    </Col>
  );
});
